import React, { useState, useEffect } from "react";
import {
  FormHelperText,
  TextField,
  Box,
  Button,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Autocomplete,
} from "@mui/material";
import * as Yup from "yup";
import { Formik } from "formik";
import useMounted from "../../../hooks/useMounted";
import toast from "react-hot-toast";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import {
  getTaskType,
  getUsersUnderAdmin,
  getTaskStatuses,
  getTaskPriorities,
  addTask,
  getProjectMilestones,
  getDropdownTasks,
} from "../../../api/project/Project";
import { makeStyles } from "@mui/styles";
import skills from "../../../@const/skills";
import moment from "moment";
import FileUploader from "../../FileUploader";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
    width: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const AddNewTaskModal = ({
  selectedProject,
  showAddTaskModal,
  setShowAddTaskModal,
  getTaskList,
  selectedMilestone,
  setaddAssignedToProjectMembers,
}) => {
  const mounted = useMounted();

  const [memberList, setMemberList] = useState([]);
  const [aallTasks, setAallTasks] = useState([]);
  const [taskStartDate, setTaskStartDate] = useState(
    moment(selectedProject.start_date)
  );
  const [taskEndDate, setTaskEndDate] = useState(
    moment(selectedProject.start_date)
  );
  const [taskTypes, setTaskTypes] = useState([]);
  const [taskStatuses, setTaskStatuses] = useState([]);
  const [milestoneTypes, setMilestoneTypes] = useState([]);

  const [taskPriorities, setTaskPriorities] = useState([]);
  const [taskAssignedTo, setTaskAssignedTo] = useState(null);

  const [selectedFile, setSelectedFile] = useState(null);

  const classes = useStyles();

  useEffect(() => {
    getTaskDropdownlist();
    getTaskPriorityTypes();
    getTaskStatusTypes();
    getMemberList();
    getTaskTypes();
    getMilestoneTypes();
  }, []);

  const getMemberList = async () => {
    const res = await getUsersUnderAdmin();
    if (res.data.success) {
      setMemberList(res.data.data.peopleDropdown);
    } else {
      console.log("No Members");
    }
  };

  const getTaskDropdownlist = async () => {
    const res = await getDropdownTasks({ projectId: selectedProject.id });
    if (res.data.success) {
      setAallTasks(res.data.data.tasks.data);
    }
  };

  const getTaskTypes = async () => {
    const res = await getTaskType();
    if (res.data.success) {
      setTaskTypes(res.data.data.taskTypes);
    }
  };

  const getMilestoneTypes = async () => {
    const res = await getProjectMilestones({ projectId: selectedProject.id });
    if (res.data.success) {
      setMilestoneTypes(res.data.data.milestoneDropdownData);
    }
  };

  const getTaskStatusTypes = async () => {
    const res = await getTaskStatuses();
    if (res.data.success) {
      setTaskStatuses(res.data.data.taskStatuses);
    }
  };

  const getTaskPriorityTypes = async () => {
    const res = await getTaskPriorities();
    if (res.data.success) {
      setTaskPriorities(res.data.data.taskPriorities);
    }
  };

  const handleUChange = (e, val) => {
    setTaskAssignedTo(val?.id || "");
  };

  return (
    <>
      <Dialog
        open={showAddTaskModal}
        onClose={() => setShowAddTaskModal(false)}
      >
        <Formik
          // enableReinitialize
          initialValues={{
            taskName: "",
            taskType: "",
            skills: [],
            taskEstimation: "",
            actualHours: 0,
            milestone: selectedMilestone || "",
            priority: "",
            belongsTo: "",
            taskStatus: "",
            taskDescription: "",
            cPerson: taskAssignedTo,
            recurringDays: 0,
            submit: null,
          }}
          validationSchema={Yup.object().shape({
            taskName: Yup.string().max(255).required("Task Name is required"),
            taskType: Yup.string().max(255).required("Task Type is required"),

            skills: Yup.array()
              .typeError("Please insert valid skills")
              .nullable(),
            priority: Yup.string()
              .typeError("Select valid priority")
              .nullable(),

            taskStatus: Yup.string()
              .max(255)
              .required("Task Status is required"),
            milestone: Yup.string().max(255).nullable(),
            taskDescription: Yup.string().max(255).nullable(),
            taskEstimation: Yup.number()
              .typeError("Hours Must be in number")
              // .max(255)
              .required("Estimated hours is required"),
            actualHours: Yup.number()
              .typeError("Hours Must be in number")
              // .max(255)
              .required("Actual hours is required"),
            recurringDays: Yup.number().typeError("Days Must be in number"),
            cPerson: Yup.number().typeError("Select a valid person").nullable(),
          })}
          onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
            try {
              let data = new FormData();
              data.append("task_doc", selectedFile);
              data.append("proj_id", selectedProject.id);
              data.append("task_name", values.taskName);
              data.append("budget", values.budget);
              data.append("task_type", values.taskType);
              data.append("task_skills", `[${values.skills.toString()}]`);
              data.append("task_estimate", values.taskEstimation);
              data.append("actual_hours", values.actualHours);
              data.append("dependent_task_id", values.belongsTo || "");
              data.append("person_id", taskAssignedTo || "");

              data.append(
                "start_date",
                moment(taskStartDate).utc().format("YYYY-MM-DD")
              );
              data.append(
                "end_date",
                moment(taskEndDate).utc().format("YYYY-MM-DD")
              );

              data.append("task_milestone", values.milestone);
              data.append("task_priority", values.priority);
              data.append("task_status", values.taskStatus);
              data.append("desc", values.taskDescription);

              if (values.recurringDays && values.recurringDays > 0) {
                data.append("recurring_days", values.recurringDays);
              }

              const res = await addTask(data);

              if (res.data.success) {
                toast.success("New task added");
                getTaskList();
                if (res.data.data.hasAssignedToNonMember) {
                  setaddAssignedToProjectMembers(res.data.data.assignedToId);
                }
                setShowAddTaskModal(false);
              }
              if (mounted.current) {
                setStatus({ success: true });
                setSubmitting(false);
              }
            } catch (err) {
              console.error(err);
              const errorMessage =
                err.response?.data?.message || "Something went wrong";
              toast.error(errorMessage);
              setStatus({ success: false });
              setErrors({ submit: errorMessage });
              setSubmitting(false);
            }
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            touched,
            values,
          }) => (
            <form
              noValidate
              onSubmit={handleSubmit}
              enctype="multipart/form-data"
            >
              <DialogTitle>Create New Task</DialogTitle>
              <DialogContent>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Task Name"
                      required
                      error={Boolean(touched.taskName && errors.taskName)}
                      fullWidth
                      helperText={touched.taskName && errors.taskName}
                      margin="normal"
                      name="taskName"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.taskName}
                      variant="outlined"
                      sx={{ mt: 0 }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ width: "100%" }}>
                      {taskTypes.length > 0 && (
                        <FormControl
                          className={classes.formControl}
                          error={Boolean(touched.taskType && errors.taskType)}
                          required
                        >
                          <InputLabel id="select-status" sx={{ color: "#bbb" }}>
                            Task Type{" "}
                          </InputLabel>
                          <Select
                            labelId="select-status"
                            label="Task Type *"
                            name="taskType"
                            value={values.taskType}
                            fullWidth
                            placeholder="Status"
                            onBlur={handleBlur}
                            onChange={handleChange}
                          >
                            {taskTypes.map((task) => (
                              <MenuItem key={task.id} value={task.id}>
                                {task.type}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText>
                            {touched.taskType && errors.taskType}
                          </FormHelperText>
                        </FormControl>
                      )}
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Estimated Hours"
                      required
                      error={Boolean(
                        touched.taskEstimation && errors.taskEstimation
                      )}
                      fullWidth
                      helperText={
                        touched.taskEstimation && errors.taskEstimation
                      }
                      margin="normal"
                      name="taskEstimation"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.taskEstimation}
                      variant="outlined"
                      sx={{ mt: 0 }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Actual Hours"
                      required
                      error={Boolean(touched.actualHours && errors.actualHours)}
                      fullWidth
                      helperText={touched.actualHours && errors.actualHours}
                      margin="normal"
                      name="actualHours"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.actualHours}
                      variant="outlined"
                      sx={{ mt: 0 }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <FormControl
                        fullWidth
                        className={classes.formControl}
                        required
                        error={!taskStartDate}
                      >
                        <DatePicker
                          label="Task Start Date"
                          value={taskStartDate}
                          onChange={(newValue) => {
                            if (newValue && moment.isMoment(newValue)) {
                              setTaskStartDate(newValue);
                              setTaskEndDate(newValue);
                            }
                          }}
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              variant: "outlined",
                              className: "pt-datepicker-ip",
                            },
                          }}
                        />
                      </FormControl>
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <FormControl
                        fullWidth
                        className={classes.formControl}
                        required
                        error={!taskEndDate}
                      >
                        <DatePicker
                          label="Task End Date"
                          value={taskEndDate}
                          onChange={(newValue) => {
                            if (newValue && moment.isMoment(newValue)) {
                              setTaskEndDate(newValue);
                            }
                          }}
                          minDate={taskStartDate}
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              variant: "outlined",
                              className: "pt-datepicker-ip",
                            },
                          }}
                        />
                      </FormControl>
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ width: "100%" }}>
                      {taskStatuses.length > 0 && (
                        <FormControl
                          className={classes.formControl}
                          error={Boolean(
                            touched.taskStatus && errors.taskStatus
                          )}
                          required
                        >
                          <InputLabel id="select-status" sx={{ color: "#bbb" }}>
                            Task Status{" "}
                          </InputLabel>
                          <Select
                            labelId="select-status"
                            label="Task Status *"
                            name="taskStatus"
                            value={values.taskStatus}
                            fullWidth
                            onBlur={handleBlur}
                            onChange={handleChange}
                          >
                            {taskStatuses.map((prior) => (
                              <MenuItem key={prior.id} value={prior.id}>
                                {prior.status}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText>
                            {touched.taskStatus && errors.taskStatus}
                          </FormHelperText>
                        </FormControl>
                      )}
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      blurOnSelect={true}
                      options={memberList}
                      onChange={handleUChange}
                      getOptionLabel={(option) =>
                        `${option.first_name} ${option.last_name}`
                      }
                      renderOption={(props, option) => {
                        return (
                          <li
                            {...props}
                            key={`${option.first_name} ${option.last_name} ${option.id}`}
                          >
                            {`${option.first_name} ${option.last_name}`}
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Assign To"
                          name="cPerson"
                          helperText={touched.cPerson && errors.cPerson}
                          error={touched.cPerson && errors.cPerson}
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Box sx={{ width: "100%" }}>
                      <FormControl
                        className={classes.formControl}
                        error={Boolean(touched.skills && errors.skills)}
                      >
                        <InputLabel id="select-status" sx={{ color: "#bbb" }}>
                          Skills
                        </InputLabel>
                        <Select
                          labelId="select-status"
                          label="skills *"
                          name="skills"
                          value={values.skills}
                          fullWidth
                          placeholder="skills"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          className="multiselect-dropdown"
                          multiple
                        >
                          {skills.length > 0 &&
                            skills.map((skill) => (
                              <MenuItem
                                className="multiselect-dropdown-menu"
                                key={skill.value}
                                value={skill.value}
                              >
                                {skill.title}
                              </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText>
                          {touched.skills && errors.skills}
                        </FormHelperText>
                      </FormControl>
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Box sx={{ width: "100%" }}>
                      <FormControl
                        className={classes.formControl}
                        error={Boolean(touched.milestone && errors.milestone)}
                        // required
                      >
                        <InputLabel id="select-status" sx={{ color: "#bbb" }}>
                          Milestone{" "}
                        </InputLabel>
                        <Select
                          disabled={selectedMilestone}
                          labelId="select-status"
                          label="Milestone"
                          name="milestone"
                          value={values.milestone}
                          fullWidth
                          placeholder="Status"
                          onBlur={handleBlur}
                          onChange={handleChange}
                        >
                          {milestoneTypes?.length === 0 && (
                            <MenuItem value="">No Data Available</MenuItem>
                          )}
                          {milestoneTypes.map((mile) => (
                            <MenuItem key={mile.id} value={mile.id}>
                              {mile.name}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>
                          {touched.milestone && errors.milestone}
                        </FormHelperText>
                      </FormControl>
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Box sx={{ width: "100%" }}>
                      {taskPriorities.length > 0 && (
                        <FormControl
                          className={classes.formControl}
                          error={Boolean(touched.priority && errors.priority)}
                        >
                          <InputLabel id="select-status" sx={{ color: "#bbb" }}>
                            Task Priority{" "}
                          </InputLabel>
                          <Select
                            labelId="select-status"
                            label="Task Priority *"
                            name="priority"
                            value={values.priority}
                            fullWidth
                            placeholder="Status"
                            onBlur={handleBlur}
                            onChange={handleChange}
                          >
                            {taskPriorities.map((prior) => (
                              <MenuItem key={prior.id} value={prior.id}>
                                {prior.priority}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText>
                            {touched.priority && errors.priority}
                          </FormHelperText>
                        </FormControl>
                      )}
                    </Box>
                  </Grid>

                  {aallTasks?.length > 0 && (
                    <Grid item xs={12} sm={6}>
                      <Box sx={{ width: "100%" }}>
                        <FormControl className={classes.formControl}>
                          <InputLabel id="select-status" sx={{ color: "#bbb" }}>
                            Parent Task{" "}
                          </InputLabel>
                          <Select
                            labelId="select-status"
                            label="Parent Task"
                            name="belongsTo"
                            value={values.belongsTo}
                            error={Boolean(
                              touched.belongsTo && errors.belongsTo
                            )}
                            fullWidth
                            helperText={touched.belongsTo && errors.belongsTo}
                            placeholder="Status"
                            onBlur={handleBlur}
                            onChange={handleChange}
                          >
                            {aallTasks.map((task) => (
                              <MenuItem key={task.id} value={task.id}>
                                {task.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>
                    </Grid>
                  )}
                  {/* Handle recurring_days */}

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Recurring days"
                      error={Boolean(
                        touched.recurringDays && errors.recurringDays
                      )}
                      fullWidth
                      helperText={touched.recurringDays && errors.recurringDays}
                      margin="normal"
                      name="recurringDays"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.recurringDays}
                      variant="outlined"
                      sx={{ mt: 0 }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FileUploader
                      onFileSelectSuccess={(file) => setSelectedFile(file)}
                      onFileSelectError={({ error }) => alert(error)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      label="Task Description"
                      error={Boolean(
                        touched.taskDescription && errors.taskDescription
                      )}
                      fullWidth
                      helperText={
                        touched.taskDescription && errors.taskDescription
                      }
                      margin="normal"
                      name="taskDescription"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.taskDescription}
                      variant="outlined"
                      sx={{ mt: 0 }}
                    />
                  </Grid>
                </Grid>

                {errors.submit && (
                  <Box sx={{ mt: 3 }}>
                    <FormHelperText error>{errors.submit}</FormHelperText>
                  </Box>
                )}
              </DialogContent>
              <DialogActions>
                <Box sx={{ display: "flex", mr: "auto", px: 2, pb: 1 }}>
                  <Box>
                    <Button
                      color="primary"
                      disabled={isSubmitting}
                      size="large"
                      type="submit"
                      variant="contained"
                    >
                      Save
                    </Button>
                  </Box>
                  <Box sx={{ ml: 1 }}>
                    <Button
                      disabled={isSubmitting}
                      size="large"
                      variant="contained"
                      onClick={() => setShowAddTaskModal(false)}
                      sx={{ backgroundColor: "#C0CBDE" }}
                    >
                      Cancel
                    </Button>
                  </Box>
                </Box>
              </DialogActions>
            </form>
          )}
        </Formik>
      </Dialog>
    </>
  );
};

export default AddNewTaskModal;
